import { useEffect, useRef, useState } from "react";

const counters = [
  { end: 5, suffix: "+", label: "NĂM KINH NGHIỆM", delay: ".2s", alt: true },
  { end: 10, suffix: "k", label: "KHÁCH HÀNG HÀI LÒNG", delay: ".4s" },
  { end: 3, suffix: "k", label: "DỰ ÁN HOÀN THÀNH", delay: ".6s", alt: true },
  { end: 50, suffix: "+", label: "GIẢI THƯỞNG ĐẠT ĐƯỢC", delay: ".8s" },
];

// Hook: chạy 1 lần khi vào viewport
const useInViewOnce = (threshold = 0.3) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!("IntersectionObserver" in window)) {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);

  return [ref, inView];
};

// Span số đếm giữ class="count"
const CountUpSpan = ({ end, duration = 1500 }) => {
  const [ref, inView] = useInViewOnce();
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let rafId;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const current = Math.round(progress * end);
      setVal(current);
      if (progress < 1) rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [inView, end, duration]);

  return (
    <span
      ref={ref}
      className="count"
      aria-label={end}
    >
      {val}
    </span>
  );
};

const CounterSection = () => {
  return (
    <section className="counter-section section-bg section-padding">
      <div className="container">
        <div className="row">
          {counters.map(({ end, suffix, label, delay, alt }, i) => (
            <div
              key={i}
              className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay={delay}
            >
              <div className={`counter-items ${alt ? "style-2" : ""}`}>
                <h2>
                  <CountUpSpan end={end} />
                  {suffix}
                </h2>
                <p>{label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
